export class ProfileDocumentModel {
    fileName: string;
    description: string;
    userDocumentType: number=1;
    phoneNumber: string;
}